import type { Variants } from 'framer-motion'

const EASE_OUT_EXPO = [0.22, 1, 0.36, 1] as const

export const fadeUp: Variants = {
  initial: { opacity: 0, y: 32 },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, ease: EASE_OUT_EXPO },
  },
}

export const staggerContainer: Variants = {
  initial: {},
  whileInView: { transition: { staggerChildren: 0.13, delayChildren: 0.05 } },
}

export const fadeUpItem: Variants = {
  initial: { opacity: 0, y: 28 },
  whileInView: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: EASE_OUT_EXPO },
  },
}

export const fadeUpBlur: Variants = {
  initial: { opacity: 0, y: 28, filter: 'blur(10px)' },
  whileInView: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: { duration: 1, ease: EASE_OUT_EXPO },
  },
}

export const viewportConfig = { once: true, margin: '-12%' } as const
